<template>
<div>

<template v-if="!sectiondata">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="sectiondata">



<template v-if="sectiondata.childsections.length>0">
<template v-if="sectiondata.section.show_subsections_as_page">

 <div class="sections pt-6 pb-6" >
  <h3 class="text-primary">{{$store.state.languages.lang_phrases.bolumler}}</h3>
  <QuestionlistPreviewSectionSelector v-for="item in sectiondata.childsections" :data="item" ></QuestionlistPreviewSectionSelector>
</div> 
</template>
</template>


<template v-if="sectiondata.childsections.length>0">
<template v-if="!sectiondata.section.show_subsections_as_page">
   <div class="sections pt-6 pb-6" >
    <hr>  
    
  <QuestionlistPreviewSubSectionView v-for="section in sectiondata.childsections" :section="section" ></QuestionlistPreviewSubSectionView>
  </div> 
</template>


</template>



<div class="inputfields pt-2"  v-if="sectiondata.inputfields.length>0">


<h3 class="text-primary">{{sectionname}}</h3>
<h5 class="pb-3" >{{sectiondescription}}</h5>

<CustomInputfield  v-for="item in sectiondata.inputfields" :data="item"></CustomInputfield>
</div>








</template>


</div>
</template>

<script>
import QuestionlistPreviewSubSectionView from "./QuestionlistPreviewSubSectionView"
export default {

  name: 'QuestionlistPreviewSection',
  components:{QuestionlistPreviewSubSectionView},
  data () {
    return {
    	data:null,
    	loading:false,
      sectiondata:null,
    }
  },
  mounted()
  {
  	this.getData()
  },
  computed:{
    sectionname()
    {      
      
      return this.getTheTranslation(this.sectiondata.section,"translation")
      
    },

    sectiondescription()
    {
      return this.getTheTranslation(this.sectiondata.section,"description")
      
    },
    inputfields_updating()
    {
      return this.$store.state.evaluation.inputfields_updating
    }
  },
  watch:{
    inputfields_updating(newval,oldval)
    {
      if(!newval)
      {
        this.getData()
      }
    }
  },
  methods:{
  	async getData()
    {
        await this.$store.dispatch('evaluation/setSectionLoading',true)
        let data = await this.arrangeAuditSectionInputfields(this.$route.params.section_id)
        await this.$store.dispatch('evaluation/setSectionLoading',false)
        this.sectiondata = await data
        //this.data = await this.generalApiGet("audit/section_fields/"+this.$route.params.section_id+"/"+this.$route.params.id)
        //await console.log(this.data);
        //await this.$store.dispatch('evaluation/setActiveSection',this.data) 
        //this.$store.dispatch('evaluation/setActiveParentSectionId',this.$route.params.section_id)
        //this.loading = await false
    }
  },
}
</script>

<style lang="css" scoped>
</style>